export interface inputValidateProps {
  key: 'reviewText' | 'reviewTitle' | 'troubleDescription';
  text: string;
}

const inputValidate = (props: inputValidateProps) => {
  const { key, text } = props;
  const { length } = text;
  let valid = false;

  switch (key) {
    case 'reviewTitle':
      valid = length >= 3 && length <= 30;
      break;
    case 'reviewText':
      valid = text.split(' ').length >= 2 && length >= 10 && length < 1000;
      break;
    case 'troubleDescription':
      valid = length >= 10 && length <= 255;
      break;
    default:
      console.error('inputValidate receive key incorrect');
      break;
  }

  return valid;
};

export default inputValidate;
export { inputValidate };
